import ledgerAPI from "@/api/ledger";
import OnDashboard from "./OnDashboard";
import OnReady from "./OnReady";

const defaultState = () => ({
  ledgerUser: {},
  fetchLedgerUserLoading: false,
  fetchLedgerUserError: false,
  fetchLedgerUserErrorResponse: null,
});

const state = defaultState();

const mutations = {
  FETCH_LEDGER_USER_BEGIN(state) {
    state.fetchLedgerUserLoading = true;
    state.fetchLedgerUserError = false;
    state.fetchLedgerUserErrorResponse = null;
  },
  FETCH_LEDGER_USER_SUCCESS(state, payload) {
    state.ledgerUser = payload;
    state.fetchLedgerUserLoading = false;
  },
  FETCH_LEDGER_USER_FAILED(state, error) {
    state.fetchLedgerUserLoading = false;
    state.fetchLedgerUserError = true;
    state.fetchLedgerUserErrorResponse = error;
  },
};

const actions = {
  async fetchLedgerUser({ commit }) {
    commit("FETCH_LEDGER_USER_BEGIN");
    try {
      const response = await ledgerAPI.fetchLedgerUser();
      commit("FETCH_LEDGER_USER_SUCCESS", response.data);
    } catch (error) {
      commit("FETCH_LEDGER_USER_FAILED", error);
    }
  },
};

const getters = {
  getLedgerUser: (state) => state.ledgerUser,
  getLedgerUserLoading: (state) => state.fetchLedgerUserLoading,
  getLedgerUserError: (state) => state.fetchLedgerUserError,
  getLedgerUserErrorResponse: (state) => state.fetchLedgerUserErrorResponse,

  hasUserGotRoles: (state) => access => {
    if(!state.ledgerUser.permissions) return false;
    let roles = state.ledgerUser.permissions.map(e => e.sid);
    return roles.some(role => access.includes(role));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    OnDashboard,
    OnReady,
  },
};